var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gtm-dashboard" },
    _vm._l(_vm.sections, function (section) {
      return _c("report-section", {
        key: section.uuid,
        attrs: {
          section: section,
          "hospital-id": _vm.hospitalId,
          "listing-id": _vm.listingId,
          "organisation-id": _vm.organisationId,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }